const PRIVATE = `
-----BEGIN RSA PRIVATE KEY-----
MIICXgIBAAKBgQ9vuppoSr7Z6Ba0RudxaTP8hqhme9ObPc4Ig6jouw4mn1BMBjBN
g+O9ZVCoqQSAGH0uMiOpVivQxILdKoYOhvoOl3/TrrMLYXXbJOzZfWtCgxsloTER
88fGDJif6+T6Nd9HAryX2LZ9/oCm3s8RUXC54XlnXO095tsF/MGtB+UUywIDAQAB
AoGBD29d/GVKUBndu04aE/TQCB56m0qWiJmTLEBRPgUwfU7bQFQ0X/oyZfeMpiFv
l8NqOUmG8yewtXEz/dKeYZuHFdzD5JsRVTN225Dowtueh+OI5WzPLwU6/36qnJgd
Qfh7KctahNpdPBS6eF6PlBjjs9NUPmB1HNMhonaTMeKmNoyZAkED77EbHCoQo/Tc
ukmcTW0aAQfvaoEMTuTAcSKPRqYdqWBa6ofOJesJIzFKZ/azaka9Kq3m3d3yq/ef
J/Zh6933lwJBA+vrri1kvDw5cECIpkmoJsNBhmmlMASyKv0VtgmfvLO9acxZGYZE
JEAvO85CaoGcSeo7zP0QeQJSs8ujp3270u0CQCmnQ3ydjISKeZlFs61LpjiGsHHR
lcWpFP9YM13zPeSjc/6f0Himx4Dp5652dyIcfHNILvPa2c4b9Ts8pv2N9k8CQQOy
G+uLZisryqnqd53XPrxBOYh2GbJWSp7O4t4q1bqd3b1OUw4GBkPvpVQEf30mZucV
84OtXw/by5scKEBZ81/FAkEAoewDP6paWSVfT2wHTUtY7wVz/9fOVrd+0XLT5rEf
9+9wLPpA7TvPskE6DsQZW2xmGxVdeKrUHefVZtyxzHduEQ==
-----END RSA PRIVATE KEY-----
`;

const PUBLIC = `
-----BEGIN PUBLIC KEY-----
MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQteSH0i9IQRWrbjchsp1QewAvV+
l/NaCnkDyIOz/0ILinaixETXPYcpDLmYSm+9TLy2cA/RW+YKnxdstnCCEUj7l16j
Z+Gkp7ZmKbK3CrwaqyzBthxyn2qYdQvMY2/pwiwCsrcE4nPGcO1amBMkPQe61q97
IuSGriJR0bzKuMr0TQIDAQAB
-----END PUBLIC KEY-----
`;

export {
    PRIVATE,
    PUBLIC
};


// WEBPACK FOOTER //
// ./src/store/variables.js